import React, { useState } from "react";
import { apiPost } from "../services/api";
import { useNavigate, Link } from "react-router-dom";
import Footer from "./Footer";

export default function StudentRegister() {
  const [enrollment, setEnrollment] = useState("");
  const [email, setemail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  // Password validation regex: min 8 chars, at least 1 uppercase, 1 lowercase, 1 number, 1 special char
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&._-])[A-Za-z\d@$!%*?&._-]{8,}$/;

  // RFC 5322 compliant standard Email Regex
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // ✅ Enrollment validation
    if (!/^\d{10}$/.test(enrollment)) {
      setError("Enrollment number must be exactly 10 digits.");
      return;
    }

    // ✅ Email syntax validation validation
    if (!emailRegex.test(email.trim())) {
      setError("Please enter a valid structural email address.");
      return;
    }

    // ✅ Password validation
    if (!passwordRegex.test(password)) {
      setError(
        "Password must be at least 8 characters long, include 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character."
      );
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        enrollment: enrollment.trim(),
        email: email.trim(),
        password: password.trim(),
      };

      const response = await apiPost("register", payload, false);

      // Explicitly check for payload error signatures or database string rejections
      if (response && (response.error || !response.success)) {
        setError(response.error || "Unable to complete registration due to a system database error.");
      } else {
        setSuccess("✅ Registration successful! Redirecting to login...");
        setTimeout(() => navigate("/"), 2000);
      }
    } catch (err) {
      setError("Database sync failure or service connection error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8 space-y-6">
        {/* University Header */}
        <div className="text-center">
          <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
            Gautam Buddha University
          </h1>
          <p className="text-gray-500 text-sm sm:text-base">
            Online Hostel Management System (OHMS)
          </p>
        </div>

        {/* Form Title */}
        <h2 className="text-center text-lg sm:text-xl font-semibold text-blue-700">
          Student Registration (2026-27)
        </h2>

        {/* Error / Success Messages */}
        {error && (
          <div className="text-red-600 bg-red-50 border border-red-200 p-3 rounded text-sm">
            {error}
          </div>
        )}
        {success && (
          <div className="text-green-600 bg-green-50 border border-green-200 p-3 rounded text-sm">
            {success}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Enrollment Number */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Enrollment Number
            </label>
            <input
              type="text"
              value={enrollment}
              onChange={(e) => setEnrollment(e.target.value)}
              maxLength={10}
              placeholder="Enter 10-digit enrollment number"
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          {/* Email*/}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setemail(e.target.value)}
              placeholder="username@domain.com"
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Min 8 chars, 1 upper, 1 lower, 1 special, 1 number"
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          {/* Confirm Password */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Confirm Password
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-lg transition disabled:opacity-50"
          >
            {loading ? "Registering..." : "Register"}
          </button>
        </form>

        {/* Login Link */}
        <div className="text-center text-sm text-gray-600">
          Already have an account?{" "}          
          <Link
            to="/"
            className="text-blue-600 font-medium hover:underline"
          >
            Login
          </Link>
        </div>
        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
}